const DEFAULT_BRAND_NAME = 'Holdshort';

/**
 * The product name for the brand this page is served under. The server renders
 * it into `window.serverData.brandName` from Twig's `_isAtp` (layout.twig), the
 * same flag that switches the logo; anything missing or blank falls back to
 * Holdshort.
 *
 * @param {object} [serverData]
 * @returns {string}
 */
export function getBrandName(serverData = window.serverData) {
	const name = serverData?.brandName;
	return typeof name === 'string' && name.trim() !== '' ? name.trim() : DEFAULT_BRAND_NAME;
}
